
import { CalculatorIcon } from '@vue-hero-icons/outline';
const AsyncEstimateRentPricingForm = () => ({
  component: import('~/components/Car/EstimateRentPricingForm.vue'),
  delay: 200,
  timeout: 3000,
});

export default {
  components: { CalculatorIcon },
  props: {
    url: {
      type: String,
      default: undefined,
    },
  },

  methods: {
    calPrice() {
      this.$vmodal.open({
        component: AsyncEstimateRentPricingForm,
        props: {},
        wrapperProps: {
          hasCheckToday: true,
          width: 690,
          clickCloseOutside: true,
          classes: 'default-car-daily-modal',
        },
      });
    },
  },
};
